import React from "react";
import * as Survey from "survey-react-ui";
import { SurveyModel } from "survey-core";
import { UseAPICaller } from "../../apiCaller";
import 'survey-core/survey-core.css';

import { BorderlessLight } from "survey-core/themes";


interface SurveyProps{
    surveyId:number;
    surveyJSON:any;
}
 
const SurveyForm : React.FC<SurveyProps> = ({surveyId, surveyJSON}) => {
    const {StoreResponses} = UseAPICaller();
    
    const survey = new SurveyModel(surveyJSON);

    survey.onComplete.add(async (sender) => {
        const answers = sender.data;
        const responseArray = Object.entries(answers).map(([key, value]) => ({
            questionId: parseInt(key),
            value
        }));

        const payload = { surveyId, answers: responseArray };
        StoreResponses(payload);
    });

    survey.applyTheme(BorderlessLight);

    return (
        <Survey.Survey model={survey} />
    );
}; 

export default SurveyForm;